import React from 'react';
import JsonEditor from '~/components/JsonEditor';
import { useGlobalState } from '~/context/GlobalStateContext';

export const TemplateEditor: React.FC = () => {
  const { generalState, setGeneralState } = useGlobalState();

  const setTemplate = React.useCallback(
    (value: string) => {
      const newState = {
        ...generalState,
        template: value,
      };
      setGeneralState(newState);
    },
    [generalState.template],
  );

  return (
    <JsonEditor
      id='template'
      code={generalState.template}
      setCode={setTemplate}
    />
  );
};
